import { A04 } from 'api/U005';

export interface DeleteResult {
  status: string;
  count: number;
  msg: string;
}

export const deleteApplicant = async (
  userId: string,
  auditionId: string,
  reason: string,
  declineKbn: string,
  examinationNo: number,
  examinationKbn: string,
  examination_s_no: number,
  result: string
) => {
  try {
    const json = await A04(
      userId,
      auditionId,
      reason,
      declineKbn,
      examinationNo,
      examinationKbn,
      examination_s_no,
      result
    );
    return {
      status: '00',
      count: json.count,
      msg: '',
    } as DeleteResult;
  } catch (err: unknown) {
    console.error(err);
    return {
      status: '99',
      count: 0,
      msg: err instanceof Error ? err.message : err,
    } as DeleteResult;
  }
};
